import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getEquipments = async (filter = {}) => {
  try {
    // Clean up the filter object - convert empty strings to null for date fields
    const cleanFilter = {
      ...filter,
      PurchaseDateFrom: filter.PurchaseDateFrom || null,
      PurchaseDateTo: filter.PurchaseDateTo || null,
      ValueDateFrom: filter.ValueDateFrom || null,
      ValueDateTo: filter.ValueDateTo || null,
      Eq_Name_English: filter.Eq_Name_English || null,
      Eq_Name_Arabic: filter.Eq_Name_Arabic || null,
      Status: filter.Status !== undefined ? filter.Status : null
    };

    const response = await axios.post(`${BASE_URL}/api/Equipment/get`, cleanFilter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching equipments:", error);
    throw error;
  }
};

export const saveEquipment = async (equipment) => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const modifiedByUserId = authUser.userId || 1;
  
  const response = await axios.post(`${BASE_URL}/api/Equipment/save?modifiedByUserId=${modifiedByUserId}`, equipment, {
    headers: getAuthHeader(),
  });
  return response.data;
};
